import horsing from '../../../../assets/svgs/actors/bennettStephanie/horsing'
import dryingTears from '../../../../assets/svgs/actors/bennettStephanie/dryingTears'

import {
    HORSING,
    DRYING_TEARS,
} from '../../../../constants/scene/actors/bennettStephanie'

export default {
    [HORSING]: horsing,
    [DRYING_TEARS]: dryingTears,
}
